// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"b3906e8e","787":"cda612ba"}[chunkId] + ".chunk.js";
};